/**
 * WebCrypto-based SHA-256 hashing for browser
 *
 * Used for content verification during artifact upload.
 * Must match server's SHA-256 implementation exactly.
 */

/**
 * Computes SHA-256 hash of content using WebCrypto API.
 * Returns lowercase hex string.
 */
export async function sha256(data: ArrayBuffer): Promise<string> {
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Computes SHA-256 hash of a File object.
 * Returns lowercase hex string.
 */
export async function sha256File(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  return sha256(buffer);
}

/**
 * Computes SHA-256 hash of a Blob object.
 * Returns lowercase hex string.
 */
export async function sha256Blob(blob: Blob): Promise<string> {
  const buffer = await blob.arrayBuffer();
  return sha256(buffer);
}
